import React, { useRef, useState } from "react";
import Confetti from "react-canvas-confetti";
import warming_up_hand from "../../../images/other/warming-up-hand.svg";
import warming_up_question_image from "../../../images/other/warming-up-question-image.jpg";
import "./About.scss";
import "./WarmingUpDesktop.scss";

const WarmingUpDesktop = () => {
    const [warmingUpAnswer, setWarmingUpAnswer] = useState("");

    const confettiRef = useRef(null);

    const makeItRain = () => {
        const confetti = confettiRef.current;

        if (confetti) {
            confetti.confetti({
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 }
            });
        }
    };

    return (
        <section className="warming-up-desktop about-section-desktop">
            <div className="wrapper">
                <div className="heading-text">Even een warming-up. <span>Geef antwoord</span> 🫣</div>
                
                <section className="question-section">
                    <img className="warming-up-hand-image" alt="" src={warming_up_hand} />

                    <div className="warming-up-hand-question">
                        <Confetti ref={confettiRef} style={{ height: "100%", width: "100%", position: "absolute", top: 0, left: 0, zIndex: 2 }} />
                        <div className="question">
                            <div className="text centered">De vrachtauto voor je is zijn vracht verloren.<br />Wat doe je?</div>
                        </div>

                        <img className="warming-up-question-image" alt="" src={warming_up_question_image} />

                        <div
                            className={"option" + (warmingUpAnswer === "" ? " active" : (warmingUpAnswer === "A" ? " incorrect" : ""))}
                            onClick={(e) => {
                                e.preventDefault();

                                if (warmingUpAnswer === "") {
                                    setWarmingUpAnswer("A");
                                }
                            }}
                        >
                            <div className="text centered">Niets</div>
                        </div>

                        <div
                            className={"option" + (warmingUpAnswer === "" ? " active" : " correct")}
                            onClick={(e) => {
                                e.preventDefault();

                                if (warmingUpAnswer === "") {
                                    setWarmingUpAnswer("B");
                                    makeItRain();
                                }
                            }}
                        >
                            <div className="text centered">De politie inschakelen</div>
                        </div>

                        <div
                            className={"option" + (warmingUpAnswer === "" ? " active" : (warmingUpAnswer === "C" ? " incorrect" : ""))}
                            onClick={(e) => {
                                e.preventDefault();

                                if (warmingUpAnswer === "") {
                                    setWarmingUpAnswer("C");
                                }
                            }}
                        >
                            <div className="text centered">De wegenwacht inschakelen</div>
                        </div>
                    </div>
                </section>
                
                <h1>Opgewarmd en klaar voor het echte werk?</h1>
            </div>
        </section>
    );
};

export default WarmingUpDesktop;